import styled from 'styled-components';

export const ContactWrapper = styled.div`
  padding-top: 1px;
  margin-left: 2px;
  display: flex;
  align-items: center;
`;

export const ContactCount = styled.div`
  position: relative;
  font-size: ${({ theme }) => theme.fontSize.xsm};
  color: var(--glz-color-neutral-tone-0);
  border-radius: 3px;
  padding: 2px;
  background-color: var(--glz-color-primary);
  margin-left: 2px;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 2.5px);
    left: -2px;
    width: 5px;
    height: 5px;
    background-color: var(--glz-color-primary);
    transform: rotate(45deg);
    z-index: -1;
  }
`;
